export const CONTACTS = {
  city: "Иркутск",
  phone: "+7 (950) 110-14-45",
  phoneRaw: "tel:+79501101445",
  telegram: "https://t.me/PodvalCapellaD",
  max: "https://max.ru/u/f9LHodD0cOKMcRZ4RJ0RL-s3H_v3p9p-hRQ1Nuvuu-nRHhvXn-nyNarjedE",
  leader: "Дианов Дмитрий",
  email: "lax-jakal@yandex.ru"
};

export const PRICING_CARDS = [
  {
    id: "cosmetic",
    title: "Косметический ремонт",
    price: "от 3000 ₽/м²",
    description: "Быстрое обновление интерьера без перепланировки и замены коммуникаций.",
    features: [
      "Замена обоев и покраска стен",
      "Укладка ламината или линолеума",
      "Монтаж плинтусов и розеток",
      "Косметическая отделка потолка",
      "Срок: от 10 дней",
    ],
    accent: false,
  },
  {
    id: "overhaul",
    title: "Капитальный ремонт",
    price: "от 8000 ₽/м²",
    description: "Комплексное переустройство помещения с заменой инженерных сетей и выравниванием поверхностей.",
    features: [
      "Полная замена электрики и сантехники",
      "Штукатурка и идеальное выравнивание стен",
      "Устройство стяжки пола и укладка плитки",
      "Демонтажные и монтажные работы",
      "Срок: от 30 дней",
    ],
    accent: true, // Highlights this card
  },
  {
    id: "designer",
    title: "Дизайнерский ремонт",
    price: "от 15000 ₽/м²",
    description: "Эксклюзивный ремонт по индивидуальному дизайн-проекту с авторским надзором.",
    features: [
      "Разработка уникального дизайн-проекта",
      "Использование премиальных отделочных материалов",
      "Сложные световые сценарии и ниши",
      "Перепланировка и зонирование пространства",
      "Срок: от 60 дней",
    ],
    accent: false,
  }
];

export const SERVICES = [
  { id: "cosmetic", title: "Косметический ремонт", desc: "Быстрое и качественное обновление интерьера квартиры.", icon: "Paintbrush" },
  { id: "overhaul", title: "Капитальный ремонт", desc: "Полное преображение с заменой всех старых коммуникаций.", icon: "Hammer" },
  { id: "designer", title: "Дизайнерский ремонт", desc: "Ремонт премиум-класса по авторскому дизайн-проекту.", icon: "Layers" },
  { id: "bathroom", title: "Ремонт ванной", desc: "Профессиональная укладка плитки и монтаж сантехники под ключ.", icon: "Bath" },
  { id: "kitchen", title: "Ремонт кухни", desc: "Эргономичные решения, монтаж электрики, вентиляции и мебели.", icon: "ChefHat" },
  { id: "plumbing", title: "Сантехника", desc: "Замена труб, разводка ХВС/ГВС, установка приборов отопления.", icon: "Droplet" },
  { id: "electrical", title: "Электрика", desc: "Монтаж проводки, щитков, розеток и сложных систем освещения.", icon: "Zap" },
  { id: "finishing", title: "Отделочные работы", desc: "Шпатлевка, грунтовка, выравнивание углов и идеальная финишная отделка.", icon: "Wand2" },
  { id: "tile", title: "Плитка", desc: "Укладка керамогранита, мозаики, затирка швов эпоксидным составом.", icon: "Grid" },
  { id: "laminate", title: "Ламинат", desc: "Настил ламината, кварцвинила, паркетной доски и подготовка основания.", icon: "HardHat" },
  { id: "ceilings", title: "Натяжные потолки", desc: "Монтаж теневых, парящих натяжных потолков с точечным светом.", icon: "Maximize" },
  { id: "painting", title: "Покраска", desc: "Высококачественная безвоздушная покраска стен и потолков.", icon: "Brush" }
];

export const ADVANTAGES = [
  { title: "Работа по договору", desc: "Официальные юридические гарантии на каждом этапе работ." },
  { title: "Фиксированная смета", desc: "Стоимость утверждается до начала работ и не меняется ни на рубль." },
  { title: "Соблюдение сроков", desc: "Выплачиваем неустойку за каждый день задержки по договору." },
  { title: "Гарантия 2 года", desc: "Уверены в качестве и несем полную ответственность за результат." },
  { title: "Бесплатный замер", desc: "Инженер приедет, проконсультирует и сделает замер абсолютно бесплатно." },
  { title: "Бесплатная консультация", desc: "Подберем оптимальное техническое решение под ваш бюджет." },
  { title: "Помощь с материалами", desc: "Закупим черновые и чистовые материалы со скидками до 20%." },
  { title: "Фотоотчет", desc: "Регулярно присылаем отчеты о ходе работ в Max, Telegram." },
  { title: "Опытные мастера", desc: "Профильные специалисты со стажем работы в ремонте от 7 лет." },
  { title: "Чистота после ремонта", desc: "Проводим влажную уборку и полностью вывозим строительный мусор." }
];

export const STAGES = [
  { step: "01", title: "Заявка", desc: "Оставляете заявку на сайте или звоните. Ответим в течение 10 минут." },
  { step: "02", title: "Бесплатный замер", desc: "Инженер выезжает на объект, проводит точные обмеры и консультирует." },
  { step: "03", title: "Подготовка сметы", desc: "Составляем прозрачную детальную смету на работы и материалы за 1 день." },
  { step: "04", title: "Договор", desc: "Фиксируем окончательную стоимость, сроки и гарантии в договоре." },
  { step: "05", title: "Выполнение ремонта", desc: "Мастера выходят на объект. Вы получаете регулярные фото/видео отчеты." },
  { step: "06", title: "Сдача объекта", desc: "Принимаете идеальный готовый ремонт. Подписываем акт, убираем мусор." }
];

// ============================================================================
// ПОРТФОЛИО ОБЪЕКТОВ
// ----------------------------------------------------------------------------
// Все фотографии хранятся ЛОКАЛЬНО в папке проекта:
//     frontend/public/images/portfolio/
// У каждого объекта — своя подпапка (object-1, object-2, ...), а внутри
// изображения пронумерованы: 1.jpg, 2.jpg, 3.jpg ...
//
// КАК ДОБАВИТЬ НОВЫЙ ОБЪЕКТ В ПОРТФОЛИО:
//   1. Создайте новую папку: frontend/public/images/portfolio/object-7/
//   2. Скопируйте туда фотографии и назовите их: 1.jpg, 2.jpg, 3.jpg ...
//   3. Добавьте новый объект в массив PORTFOLIO_ITEMS ниже (можно скопировать
//      любой существующий блок) и укажите пути к своим фото в поле "images".
//   4. Уникальный "id", заголовок "title", описание "desc" и теги "tags".
//
// КАК ЗАМЕНИТЬ ФОТО существующего объекта:
//   Просто положите новый файл с тем же именем (например, 1.jpg) в нужную
//   папку object-N — путь в данных менять не нужно.
//
// ВАЖНО: используются ТОЛЬКО локальные пути вида "/images/portfolio/...".
// Внешние (Unsplash/Pexels) ссылки больше не применяются.
// Если какого-то файла не окажется на месте — вместо него автоматически
// покажется заглушка PORTFOLIO_PLACEHOLDER (см. обработку onError в App.js).
// ============================================================================

// Заглушка, которая показывается, если файл изображения отсутствует
export const PORTFOLIO_PLACEHOLDER = "/images/portfolio/placeholder.svg";

export const PORTFOLIO_ITEMS = [
  {
    id: 1,
    title: "Дизайнерский ремонт под ключ",
    desc: "ЖК Стрижи Сити — Площадь: 93 м²",
    price: "1 700 000 ₽",
    description: "Дизайнерский ремонт квартиры под ключ, реализованный по индивидуальному проекту с полным комплексом черновых и чистовых отделочных работ.\n\nВ ходе ремонта выполнены работы по устройству инженерных коммуникаций, монтажу электрики и сантехники, подготовке и выравниванию поверхностей, отделке стен и потолков, укладке напольных покрытий и чистовому монтажу.\n\nОсобое внимание уделено дизайну и геометрии пространства: продуманы сценарии освещения, реализованы сложные узлы и авторские решения интерьера, использованы премиальные отделочные материалы.\n\nВсе работы выполнены нашей командой от чернового этапа до полной сдачи объекта заказчику. На фотографиях представлен реальный результат завершенного проекта.",
    images: [
      "/images/portfolio/object-strizhi/5.webp",
      "/images/portfolio/object-strizhi/4.webp",
      "/images/portfolio/object-strizhi/3.webp",
      "/images/portfolio/object-strizhi/2.webp",
      "/images/portfolio/object-strizhi/1.webp",
      "/images/portfolio/object-strizhi/10.webp",
      "/images/portfolio/object-strizhi/6.webp",
      "/images/portfolio/object-strizhi/7.webp",
      "/images/portfolio/object-strizhi/8.webp",
      "/images/portfolio/object-strizhi/9.webp",
      "/images/portfolio/object-strizhi/11.webp",
      "/images/portfolio/object-strizhi/12.webp",
      "/images/portfolio/object-strizhi/13.webp",
      "/images/portfolio/object-strizhi/14.webp",
      "/images/portfolio/object-strizhi/15.webp",
      "/images/portfolio/object-strizhi/16.webp",
      "/images/portfolio/object-strizhi/17.webp"
      
    ],
    tags: ["Дизайнерский", "Под ключ", "ЖК Стрижи Сити"]
  },
  {
    id: 2,
    title: "Капитальный ремонт под ключ",
    desc: "ЖК Авиатор — Площадь: 88,4 м²",
    price: "1 654 000 ₽",
    description: "Проект реализован в новостройке с выполнением полного комплекса черновых и чистовых отделочных работ. В ходе ремонта были выполнены работы по устройству инженерных коммуникаций, монтажу электрики и сантехники, подготовке оснований, отделке стен, укладке напольных покрытий и чистовому монтажу.\n\nОсобое внимание уделялось качеству подготовки поверхностей и геометрии помещений. Выполнена укладка плитки и керамогранита с точной подрезкой и соблюдением рисунка материалов. Все примыкания, швы и узлы выполнены аккуратно и с учетом дальнейшей эксплуатации помещения.\n\nВ санузле смонтирована современная сантехника, выполнена облицовка крупноформатной плиткой, организовано функциональное хранение и продуманы сценарии освещения. При выполнении работ использовались современные материалы и решения, обеспечивающие долговечность и удобство эксплуатации.\n\nНа фотографиях представлен реальный объект после завершения ремонта. Все работы выполнены нашей бригадой от чернового этапа до полной готовности помещений.",
    images: [
      "/images/portfolio/object-1/12.jpg",
      "/images/portfolio/object-1/15.jpg",
      "/images/portfolio/object-1/14.jpg",
      "/images/portfolio/object-1/13.jpg",
      "/images/portfolio/object-1/2.jpg",
      "/images/portfolio/object-1/5.jpg",
      "/images/portfolio/object-1/9.jpg",
      "/images/portfolio/object-1/1.jpg",
      "/images/portfolio/object-1/6.jpg",
      "/images/portfolio/object-1/10.jpg",
      "/images/portfolio/object-1/11.jpg",
      "/images/portfolio/object-1/3.jpg",
      "/images/portfolio/object-1/7.jpg",
      "/images/portfolio/object-1/8.jpg",
      "/images/portfolio/object-1/4.jpg"
    ],
    tags: ["Капитальный", "Под ключ", "ЖК Авиатор"]
  },
  {
    id: 3,
    title: "Капитальный ремонт квартиры под ключ",
    desc: "6-я Советская — Площадь: 72 м²",
    price: "950 000 ₽",
    description: "Проект реализован в новостройке с выполнением полного комплекса черновых и чистовых отделочных работ. В ходе ремонта были выполнены работы по устройству инженерных коммуникаций, монтажу электрики и сантехники, подготовке оснований, отделке стен, укладке напольных покрытий и чистовому монтажу.\n\nОсобое внимание уделялось качеству подготовки поверхностей и геометрии помещений. Выполнена укладка плитки и керамогранита с точной подрезкой и соблюдением рисунка материалов. Все примыкания, швы и узлы выполнены аккуратно и с учетом дальнейшей эксплуатации помещения.\n\nВ санузле смонтирована современная сантехника, выполнена облицовка крупноформатной плиткой, организовано функциональное хранение и продуманы сценарии освещения. При выполнении работ использовались современные материалы и решения, обеспечивающие долговечность и удобство эксплуатации.\n\nНа фотографиях представлен реальный объект после завершения ремонта. Все работы выполнены нашей бригадой — от чернового этапа до полной готовности квартиры к проживанию.",
    images: [
      "/images/portfolio/object-2/4.jpg",
      "/images/portfolio/object-2/1.jpg",
      "/images/portfolio/object-2/2.jpg",
      "/images/portfolio/object-2/3.jpg",
      "/images/portfolio/object-2/5.jpg",
      "/images/portfolio/object-2/6.jpg",
      "/images/portfolio/object-2/7.jpg",
      "/images/portfolio/object-2/8.jpg",
      "/images/portfolio/object-2/9.jpg",
      "/images/portfolio/object-2/10.jpg",
      "/images/portfolio/object-2/11.jpg",
      "/images/portfolio/object-2/12.jpg",
      "/images/portfolio/object-2/13.jpg",
      "/images/portfolio/object-2/14.jpg",
      "/images/portfolio/object-2/15.jpg",
      "/images/portfolio/object-2/16.jpg",
      "/images/portfolio/object-2/17.jpg",
      "/images/portfolio/object-2/18.jpg",
      "/images/portfolio/object-2/19.jpg",
      "/images/portfolio/object-2/20.jpg",
      "/images/portfolio/object-2/21.jpg",
      "/images/portfolio/object-2/22.jpg",
      "/images/portfolio/object-2/23.jpg",
      "/images/portfolio/object-2/24.jpg",
      "/images/portfolio/object-2/25.jpg",
      "/images/portfolio/object-2/26.jpg",
      "/images/portfolio/object-2/27.jpg",
      "/images/portfolio/object-2/28.jpg",
      "/images/portfolio/object-2/29.jpg",
      "/images/portfolio/object-2/30.jpg",
      "/images/portfolio/object-2/31.jpg",
      "/images/portfolio/object-2/32.jpg",
      "/images/portfolio/object-2/33.jpg",
      "/images/portfolio/object-2/34.jpg",
      "/images/portfolio/object-2/35.jpg",
      "/images/portfolio/object-2/36.jpg",
      "/images/portfolio/object-2/37.jpg",
      "/images/portfolio/object-2/38.jpg",
      "/images/portfolio/object-2/39.jpg"
    ],
    tags: ["Капитальный", "Под ключ", "6-я Советская"]
  },
  {
    id: 4,
    title: "Дизайнерская квартира-студия под ключ",
    desc: "ЖК 4 Солнца — Площадь: 40 м²",
    price: "821 000 ₽",
    description: "Современная квартира-студия с полной реализацией проекта под ключ.\n\nВ рамках данного объекта был выполнен комплекс ремонтно-отделочных работ с последующим обустройством жилого пространства и изготовлением мебели по индивидуальным размерам.\n\nНа объекте произведены работы по устройству инженерных коммуникаций, монтажу электрики и сантехники, подготовке поверхностей, отделке стен и потолков, укладке напольных покрытий, облицовке санузла керамогранитом и установке всей чистовой сантехники.\n\nОсобое внимание было уделено эргономике пространства. Для квартиры разработаны и изготовлены встроенные системы хранения, шкаф-купе, кухонный гарнитур и барная зона, позволившие максимально эффективно использовать площадь помещения.\n\nИнтерьер выполнен в современном стиле с сочетанием натуральных древесных текстур, спокойных оттенков и продуманного освещения. В санузле установлена душевая зона со стеклянным ограждением, подвесная сантехника и встроенные системы хранения.\n\nВсе работы выполнены нашей командой от чернового этапа до полной сдачи объекта заказчику. На фотографиях представлен реальный результат завершенного проекта.",
    images: [
      "/images/portfolio/object-3/s1.jpg",
      "/images/portfolio/object-3/s2.jpg",
      "/images/portfolio/object-3/s3.jpg",
      "/images/portfolio/object-3/s4.jpg",
      "/images/portfolio/object-3/s5.jpg",
      "/images/portfolio/object-3/s6.jpg",
      "/images/portfolio/object-3/s7.jpg",
      "/images/portfolio/object-3/s8.jpg",
      "/images/portfolio/object-3/s9.jpg",
      "/images/portfolio/object-3/s10.jpg",
      "/images/portfolio/object-3/s11.jpg",
      "/images/portfolio/object-3/s12.jpg"
    ],
    tags: ["Под ключ", "Студия", "ЖК 4 Солнца"]
  },
  {
    id: 5,
    title: "Санузел в стиле лофт под ключ",
    desc: "ЖК Квартал — Площадь: 8 м²",
    images: [
      "/images/portfolio/object-4/1.jpg",
      "/images/portfolio/object-4/2.jpg",
      "/images/portfolio/object-4/3.jpg"
    ],
    tags: ["Санузел", "Керамогранит"]
  },
  {
    id: 6,
    title: "Светлая детская комната",
    desc: "ЖК Символ — Площадь: 45 м²",
    images: [
      "/images/portfolio/object-5/1.jpg",
      "/images/portfolio/object-5/2.jpg",
      "/images/portfolio/object-5/3.jpg"
    ],
    tags: ["Косметический", "Детская"]
  }
];

export const TESTIMONIALS = [
  {
    name: "Константин Е.",
    project: "Ремонт 2-комнатной квартиры под ключ",
    text: "Ребята превзошли все ожидания! Скидка для участников СВО и их семей была очень ценной и благородной поддержкой. Смета была составлена в день обращения, и цена не изменилась ни на копейку до сдачи объекта. Качество ремонта — безупречное, мастера профессионалы своего дела. Рекомендую Дмитрия и его команду!",
    rating: 5,
    date: "14.10.2025"
  },
  {
    name: "Мария С.",
    project: "Дизайнерский ремонт студии, ЖК Новый",
    text: "Очень переживала за сроки, так как уезжала в командировку. Дмитрий регулярно присылал детальные фото- и видеоотчеты в Telegram, полностью координировал закупку материалов. Закончили даже на 3 дня раньше срока! Идеальная чистота после ремонта, квартира блестит.",
    rating: 5,
    date: "05.11.2025"
  },
  {
    name: "Алексей и Ольга",
    project: "Капитальный ремонт ванной и кухни, ул. Лермонтова",
    text: "Искали опытную команду для сложного ремонта сантехники и электрики. Ребята из ФОРМАТ сделали идеальную разводку ХВС/ГВС и продумали все розетки. Плитка уложена стык в стык, швы ровные. Огромное спасибо руководителю Дмитрию за профессиональный контроль!",
    rating: 5,
    date: "28.11.2025"
  }
];

export const FAQ_ITEMS = [
  {
    question: "Сколько стоит ремонт?",
    answer: "Стоимость ремонта зависит от выбранного типа и площади помещения: Косметический — от 3 000 ₽/м², Капитальный — от 8 000 ₽/м², Дизайнерский — от 15 000 ₽/м². Вы можете воспользоваться нашим интерактивным калькулятором ниже для примерного расчета или заказать бесплатный выезд замерщика для составления точной сметы."
  },
  {
    question: "Сколько длится ремонт?",
    answer: "Сроки строго фиксируются в договоре: косметический ремонт занимает от 10 до 20 дней, капитальный — от 30 до 50 дней, дизайнерский ремонт по индивидуальному проекту — от 2 до 3 месяцев в зависимости от сложности работ."
  },
  {
    question: "Есть ли гарантия?",
    answer: "Да, на все виды ремонтно-отделочных и монтажных работ мы предоставляем официальную гарантию 2 года. Все гарантийные обязательства четко прописаны в договоре."
  },
  {
    question: "Работаете ли по договору?",
    answer: "Да, работа по официальному договору — наше обязательное условие. В договоре закрепляется фиксированная смета (цена не вырастет), точные сроки выполнения работ и наши гарантийные обязательства."
  },
  {
    question: "Делаете бесплатный замер?",
    answer: "Выезд инженера-замерщика, консультация по технологиям и составление детальной сметы осуществляются полностью бесплатно в Иркутске и пригороде. Это вас ни к чему не обязывает."
  },
  {
    question: "Помогаете купить материалы?",
    answer: "Да, мы полностью берем на себя заботу о материалах. У нас налажены партнерские связи с крупными строительными базами Иркутска, что позволяет нам закупать качественные черновые и чистовые материалы со скидками до 20%, экономя ваше время и деньги."
  }
];
